import { isProd } from 'config/config';
import { getRegisteredSessions, unregisterSession } from 'helpers/api';
import { formatDate, nullCheckForCardCreation } from 'helpers/utils';

const state = {
    navSet: false,
    type: null,
    coursesPage: isProd ? '/portal/training-and-events' : '/training-and-events.html',
    schoolPage: isProd ? '/portal/training-and-events/update-schools' : 'update-schools.html',
    courseInfo: isProd
        ? '/portal/training-and-events/more-information'
        : '/training-more-info.html',
    schoolInfo: isProd
        ? '/portal/training-and-events/schools-more-information'
        : '/schools-more-information.html',
    register: isProd ? '/portal/training-and-events/registered-events' : 'registered-events.html',
    unregister: '',
};

const setListeners = () => {
    state.unregister = document.querySelectorAll('[data-label=Unregister]') || null;
    state.unregister.forEach((i) => {
        if (!i.classList.contains(`unclickable`)) {
            i.addEventListener('click', () => {
                unregisterFromSession(
                    document.getElementsByName('id')[i.id].value,
                    document.getElementsByName('name')[i.id].value,
                    document.getElementsByName('title')[i.id].value,
                );
            });
        }
    });
};

// ==================================================
// HANDLERS
// ==================================================

async function fetchAndHandleSessions() {
    state.type = 'Registered';
    const { data } = await getRegisteredSessions();
    if (!data.length) {
        return (document.getElementsByClassName('js--register-events')[0].innerHTML =
            notRegistered());
    }
    const sessionList = document.getElementsByClassName('js--register-events')[0] || null;
    if (document.getElementsByClassName('register').length > 0) {
        document
            .getElementsByClassName('register')[0]
            .style.setProperty('$numRows', sessionList.length);
    }

    await nullCheckForCardCreation(sessionList, data, card);
}

function unregisterFromSession(id, technician, title) {
    if (window.confirm(`Are you sure you want to unregister ${technician} from ${title}?`)) {
        unregisterSession(id);
    }
}

function handleNav() {
    state.navSet = document.getElementsByTagName('section')[0].getAttribute('data-type');
    switch (state.navSet) {
        case 'UpdateSchool':
            document.getElementsByClassName('dashboard__subnav')[0].innerHTML = nav(
                true,
                false,
                false,
            );
            break;
        case 'Course':
            document.getElementsByClassName('dashboard__subnav')[0].innerHTML = nav(
                false,
                true,
                false,
            );
            break;
        case 'Registered':
            document.getElementsByClassName('dashboard__subnav')[0].innerHTML = nav(
                false,
                false,
                true,
            );
            break;
        default:
            break;
    }
}

// ==================================================
// HELPERS
// ==================================================

const notRegistered = () => `
<li class="js--ob-no-items list-grid__results__no-items">
    <div class="list-grid__results__item">
        <p>No Items Selected.</p>
    </div>
</li>`;

const card = (
    { CourseTitle, StudentName, StartDate, EndDate, CourseType, CourseId, RegistrationId, Status },
    id,
) => {
    const today = new Date();
    const endDate = new Date(EndDate);
    const startDate = new Date(StartDate);
    let btn = ``;
    let style = ``;
    switch (Status) {
        case `Pending`:
            btn = `Unregister`;
            style = ``;
            break;
        case `Cancelled`:
            btn = `Cancelled`;
            style = `unclickable`;
            break;
        case `Paid`:
            btn = `Paid`;
            style = `unclickable`;
            break;
        default:
            btn = `Unregister`;
            style = ``;
            break;
    }
    return `<a class="margin-top-10 padding-left-15 padding-top-15 padding-bottom-15 grid-child R${id + 2
        }-${id + 2} C1-1 dashboard__subnav__link--nofluff" href="${CourseType === 'UpdateSchool' ? state.schoolInfo : state.courseInfo
        }?sessionId=${CourseId}">${CourseTitle}</a>
  <div class="margin-top-10 padding-top-15 padding-bottom-15 grid-child R${id + 2}-${id + 2
        } C2-2" data-label="Registrant">${StudentName}</div>
  <div class="margin-top-10 padding-top-15 padding-bottom-15 grid-child R${id + 2}-${id + 2
        } C3-3" data-label="Start Date">${formatDate(StartDate)}</div>
  <div class="margin-top-10 padding-top-15 padding-bottom-15 grid-child R${id + 2}-${id + 2
        } C4-4" data-label="End Date">${formatDate(EndDate)}</div>
  <div id="${id}" class="margin-top-10 margin-right-10 margin-left-10 padding-top-15 padding-bottom-15 db-nav__user__dropdown-logout grid-child R${id + 2
        }-${id + 2} C5-5 ${style}" data-label="Unregister">${btn}</div>
  <input name="title" type="hidden" value="${CourseTitle}">
  <input name="name" type="hidden" value="${StudentName}">
  <input name="id" type="hidden" value="${RegistrationId}">`;
};

const nav = (USActive = false, CActive = false, REActive = false) => `
<a href="${state.schoolPage}" class="dashboard__subnav__link ${USActive ? 'dashboard__subnav--active' : ''
    }">Update Schools</a>
<a href="${state.coursesPage}" class="dashboard__subnav__link ${CActive ? 'dashboard__subnav--active' : ''
    }">Courses</a>
<a href="${state.register}" class="dashboard__subnav__link ${REActive ? 'dashboard__subnav--active' : ''
    }">Registered Events</a>`;

// ==================================================
// INIT
// ==================================================

async function init() {
    await fetchAndHandleSessions();
    setListeners();
    handleNav();
}

export default init;



// WEBPACK FOOTER //
// ./app/js/modules/registered-events.js